// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import DisplayText from './DisplayText';

type Props = {
  themeColor?: string,
  children: React.Node
};

export function HeaderText({ children, themeColor }: Props) {
  return (
    <DisplayText fontSize="20px" themeColor={themeColor || 'regularTextColor'} bold>
      {children}
    </DisplayText>
  );
}

HeaderText.propTypes = {
  themeColor: PropTypes.string
};

export default HeaderText;
